import { lazy, Suspense, useEffect, useRef, useState } from "react";
import HeroSection from "./HeroSection";
import Footer from "./Footer";

const ProjectsSection = lazy(() => import("./ProjectsSection"));
const AboutSection = lazy(() => import("./AboutSection"));
const SetupSection = lazy(() => import("./SetupSection"));
const StatsSection = lazy(() => import("./StatsSection"));
const GuestbookSection = lazy(() => import("./GuestbookSection"));
const ContactSection = lazy(() => import("./ContactSection"));
const DomainsSection = lazy(() => import("./DomainsSection"));

function SectionFallback() {
  return <div className="h-48" aria-hidden="true" />;
}

function DeferredSection({ children }) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setIsVisible(true);
      observer.disconnect();
    }, { rootMargin: "300px" });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return <div ref={ref}>{isVisible ? children : <SectionFallback />}</div>;
}

export default function PageLayout() {
  return (
    <div className="min-h-screen bg-zinc-950 relative overflow-x-hidden">
      {/* Subtle top ambient glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[450px] bg-gradient-to-b from-violet-600/10 via-violet-900/5 to-transparent blur-3xl opacity-60"
      />
      <a className="skip-link" href="#main-content">Skip to content</a>
      <main id="main-content">
        <HeroSection />
        <DeferredSection><Suspense fallback={<SectionFallback />}><AboutSection /></Suspense></DeferredSection>
        <DeferredSection><Suspense fallback={<SectionFallback />}><ProjectsSection /></Suspense></DeferredSection>
        <DeferredSection><Suspense fallback={<SectionFallback />}><SetupSection /></Suspense></DeferredSection>
        <DeferredSection><Suspense fallback={<SectionFallback />}><StatsSection /></Suspense></DeferredSection>
        <DeferredSection><Suspense fallback={<SectionFallback />}><DomainsSection /></Suspense></DeferredSection>
        <DeferredSection><Suspense fallback={<SectionFallback />}><GuestbookSection /></Suspense></DeferredSection>
        <DeferredSection><Suspense fallback={<SectionFallback />}><ContactSection /></Suspense></DeferredSection>
      </main>
      <Footer />
    </div>
  );
}
